@if (!isLoading) {
  <div>
    @if (!isRange) {
      @if (!solrDataOption?.allowMultipleSelections) {
        <ng-template [ngTemplateOutlet]="singleInput"></ng-template>
      } @else {
        @if (solrDataOption) {
          <rl-multi-value-input [solrDataOption]="solrDataOption" [values]="values"
          (onChange)="emitMultiValues($event)"></rl-multi-value-input>
        }
      }
    } @else {
      @if (solrDataOption) {
        <rl-range-value-input [solrDataOption]="solrDataOption" [values]="values"
        (onChange)="emitRange($event)"></rl-range-value-input>
      }
    }
    <ng-template #singleInput>
      @if (solrDataOption) {
        <rl-single-value-input [solrDataOption]="solrDataOption" [values]="values"
        (onChange)="emitSingle($event)"></rl-single-value-input>
      }
    </ng-template>
  </div>
}